<template>
  <div class="search-box">
    <div class="time-list">
      <div class="item" :class="{active:index===timeIndex}" v-for="(item,index) in timeList" :key="index" @click="changeTime(index)">{{ item }}</div>
    </div>
    <div class="time-change">
      <el-date-picker v-model="timeShow" size="small" type="daterange" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" @change="confirmTime"></el-date-picker>
    </div>
  </div>
</template>

<script>
  export default{
    data() {
      return {
        timeList: ['今日','本周','本月'], //时间列表
        timeIndex: 0, //当前选择
        timeShow: '', //显示时间
        timeStart: '', //开始时间
        timeEnd: '', //结束时间
      }
    },
    methods: {
      // 时间选择
      changeTime(index) {
        if(index===this.timeIndex) return;
        this.timeIndex = index;
        this.timeShow = '';
        const now = new Date();
        const currentYear = now.getFullYear();
        const currentMonth = (now.getMonth() + 1 + "").padStart(2,"0");
        const currentDate = (now.getDate() + "").padStart(2,"0");
        const currentWeek = now.getDay();
        const baseTime = `${currentYear}-${currentMonth<10?'0'+currentMonth:currentMonth}-${currentDate<10?'0'+currentDate:currentDate}`;
        switch (index){
          case 0: //本日
            // 计算时间
            this.timeStart = `${currentYear}-${currentMonth}-${currentDate} 00:00:00`;
            this.timeEnd = `${currentYear}-${currentMonth}-${currentDate} 23:59:59`;
            break;
          case 1: //本周
            const today = this.dayjs();
            const dayOfWeek = today.day();
            const monday = today.subtract(dayOfWeek, 'day').add(1,'day');
            const sunday = monday.add(6, 'day');
            // console.log('monday',monday,sunday,monday,sunday)
            // 计算时间
            this.timeStart = `${monday.format('YYYY-MM-DD')} 00:00:00`;
            this.timeEnd = `${sunday.format('YYYY-MM-DD')} 23:59:59`;
            break;
          case 2: //本月
            // 计算时间
            this.timeStart = `${currentYear}-${currentMonth}-01 00:00:00`;
            this.timeEnd = `${currentYear}-${currentMonth}-${currentDate} 23:59:59`;
            break;
        }

        // 传值
        let emitObj = {
          timeStart: this.timeStart,
          timeEnd: this.timeEnd,
          // timeIndex: this.timeIndex,
          ifUse: false
        }
        this.$emit('getTime', JSON.stringify(emitObj));
      },
      confirmTime() {
        // 数据处理
        // this.timeIndex = '';
        this.timeStart = `${this.timeShow[0]} 00:00:00`;
        this.timeEnd = `${this.timeShow[1]} 23:59:59`;
        // 传值
        let emitObj = {
          timeStart: this.timeStart,
          timeEnd: this.timeEnd,
          // timeIndex: this.timeIndex,
          ifUse: true
        }
        this.$emit('getTime', JSON.stringify(emitObj));
      }
    }
  }
</script>

<style scoped lang="scss">
  .search-box {
    display: flex;
    align-items: center;
    margin-bottom: 22px;
    .time-list {
      display: flex;
      align-items: center;
      .item {
        margin-right: 16px;
        font-size: 16px;
        cursor: pointer;
        &.active {
          color: #1596CD;
          font-weight: bold;
        }
      }
    }
    .time-change {
      margin-right: 60px;
    }
  }
</style>
